// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.automation-rule-modal .add-automation-modal__sidebar {
  flex: 0 0 33.33%;
  max-width: 33.33%;
}
@media (max-width: 768px) {
  .automation-rule-modal .add-automation-modal__sidebar {
    flex: none;
    max-width: none;
    width: 100%;
  }
}
/*# sourceMappingURL=AutomationRuleModal.css.map */`, "",{"version":3,"sources":["webpack://./AutomationRuleModal.less","webpack://./wp_components/PositionAutomation/components/AutomationRuleModal.less"],"names":[],"mappings":"AAAA;EAEQ,gBAAA;EACA,iBAAA;ACAR;ADIA;EACI;IAEQ,UAAA;IACA,eAAA;IACA,WAAA;ECHV;AACF;AACA,kDAAkD","sourcesContent":[".automation-rule-modal {\n    .add-automation-modal__sidebar {\n        flex: 0 0 33.33%;\n        max-width: 33.33%;\n    }\n}\n\n@media (max-width: 768px) {\n    .automation-rule-modal {\n        .add-automation-modal__sidebar {\n            flex: none;\n            max-width: none;\n            width: 100%;\n        }\n    }\n}\n",".automation-rule-modal .add-automation-modal__sidebar {\n  flex: 0 0 33.33%;\n  max-width: 33.33%;\n}\n@media (max-width: 768px) {\n  .automation-rule-modal .add-automation-modal__sidebar {\n    flex: none;\n    max-width: none;\n    width: 100%;\n  }\n}\n/*# sourceMappingURL=AutomationRuleModal.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
